import {Dialog} from '@common/ui/overlays/dialog/dialog';
import {DialogHeader} from '@common/ui/overlays/dialog/dialog-header';
import {Trans} from '@common/i18n/trans';
import {DialogBody} from '@common/ui/overlays/dialog/dialog-body';
import {useDialogContext} from '@common/ui/overlays/dialog/dialog-context';
import {useForm} from 'react-hook-form';
import {Form} from '@common/ui/forms/form';
import {DialogFooter} from '@common/ui/overlays/dialog/dialog-footer';
import {Button} from '@common/ui/buttons/button';
import { LoanProductPayload, useCreateLoanProduct } from '@app_modules/requests/use-create-loan-product';
import { CrupdateLoanProductFields } from './crupdate-loan-product-fields';
// import { CrupdateLoanProductFields } from './crupdate-loan-product-fields';

export function CreateLoanProductDialog() {
  const {formId, close} = useDialogContext();
  const form = useForm<LoanProductPayload>();
  const createLoanProduct = useCreateLoanProduct(form);
  return (
    <Dialog>
      <DialogHeader>
        <Trans message="New Loan Product" />
      </DialogHeader>
      <DialogBody>
        <Form
          id={formId}
          form={form}
          onSubmit={value => {
            createLoanProduct.mutate(value, {
              onSuccess: () => close(),
            });
          }}
        >
          <CrupdateLoanProductFields />
        </Form>
      </DialogBody>
      <DialogFooter>
        <Button onClick={() => close()}>
          <Trans message="Cancel" />
        </Button>
        <Button
          form={formId}
          type="submit"
          variant="flat"
          color="primary"
          disabled={createLoanProduct.isPending}
        >
          <Trans message="Create" />
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
